export default "__VITE_ASSET__D5x9VDcN__"